import { useState, useEffect } from "react";
import Head from "next/head";
import BlogCard from "../../components/blogs/BlogCard";
import Nav from "../../components/blogs/Nav";
import PageName from "../../components/pagename";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import axios from "../../Axios";

export default function Blogs({ allBlogs, categories, categoryBlogs }) {
  const t = useTranslations("blogs");
  const router = useRouter();
  const [filteredBlogs, setFilteredBlogs] = useState(allBlogs);
  const [search, setSearch] = useState("");
  const [lang, setLang] = useState(router.locale);
  const [loading, setLoading] = useState(false);

  async function fetchData() {
    setLoading(true);
    const response = await axios.get(
      `${process.env.NEXT_APP_BACKEND_URL}user/category/filter_catogrey/?categoryName=${router.query.categoryName}&lang=${router.locale}`
    );
    setFilteredBlogs(response?.data?.result);
    setLoading(false);
  }
  useEffect(() => {
    const { categoryName } = router.query;
    if (categoryName) {
      const newFilteredBlogs = allBlogs.filter(
        (blog) => blog.categoryName._id == categoryName
      );
      setFilteredBlogs(newFilteredBlogs);
    } else {
      setFilteredBlogs(allBlogs);
    }
    // fetch arabic blogs if arabic is selected and store them in allBlogs
    setLang(router.locale);
  }, [router.query.categoryName, router.locale]);

  async function handleCategoryClick(categoryName) {
    router.push({ pathname: "/blogs", query: { categoryName } });
  }

  function handleAllBlogsClick() {
    // Show all blogs
    router.push({ pathname: "/blogs" });
    setFilteredBlogs(allBlogs);
    setSearch("");
  }

  function handleSearch(search) {
    // filter blogs based on search term
    const { categoryName } = router.query;

    if (categoryName) {
      const newFilteredBlogs = allBlogs.filter(
        (blog) =>
          blog.categoryName._id == categoryName &&
          blog.title.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredBlogs(newFilteredBlogs);
    } else {
      const newFilteredBlogs = allBlogs.filter((blog) =>
        blog.title.toLowerCase().includes(search.toLowerCase())
      );
      setFilteredBlogs(newFilteredBlogs);
    }
  }

  return (
    <>
      <Head>
        <title>Blogs | Ascot Enterprise Solutions</title>
      </Head>
      <div key={lang}>
        <PageName title={t("ourBlog")} img="career/Lightbulb" />
        <div className=" xl:mx-auto responsive max-w-[90rem] mb-[96px]">
          {/* Container */}
          <div key={lang} className="py-5 grid grid-cols-12">
            <div className="col-span-12">
              <Nav
                categories={categories}
                onCategoryClick={handleCategoryClick}
                onAllBlogsClick={handleAllBlogsClick}
                onSearch={handleSearch}
                search={search}
                t={t}
              />
            </div>
            {/* Blogs Navbar */}

            {/* Blog Posts */}

            {/*------ Skeleton Loaders -------- */}
            <div className="col-span-12">
              {loading ? (
                <div className="grid grid-cols-12 gap-5">
                  <div className="animate-pulse col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4 h-[292px] lg:h-[326px] bg-gray-200 rounded p-10 flex flex-col justify-end">
                    {/* Customize the content of the skeleton card */}
                    <div className="h-6 w-1/2 bg-gray-300 mb-2"></div>
                    <div className="h-4 w-1/4 bg-gray-300 mb-1"></div>
                    <div className="h-4 w-3/4 bg-gray-300 mb-1"></div>
                  </div>
                  <div className="animate-pulse col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4 h-[292px] lg:h-[326px] bg-gray-200 rounded p-10 flex flex-col justify-end">
                    {/* Customize the content of the skeleton card */}
                    <div className="h-6 w-1/2 bg-gray-300 mb-2"></div>
                    <div className="h-4 w-1/4 bg-gray-300 mb-1"></div>
                    <div className="h-4 w-3/4 bg-gray-300 mb-1"></div>
                  </div>
                  <div className="animate-pulse col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4 h-[292px] lg:h-[326px] bg-gray-200 rounded p-10 flex flex-col justify-end">
                    {/* Customize the content of the skeleton card */}
                    <div className="h-6 w-1/2 bg-gray-300 mb-2"></div>
                    <div className="h-4 w-1/4 bg-gray-300 mb-1"></div>
                    <div className="h-4 w-3/4 bg-gray-300 mb-1"></div>
                  </div>
                </div>
              ) : (
                // Render the BlogCard component with the filtered blogs
                <BlogCard blogs={filteredBlogs} t={t} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps({ locale, query }) {
  const lang = locale;
  const { categoryName } = query;
  try {
    const allBlogsData = await axios.get(`user/blog/all-blogs?lang=${lang}`);
    const allBlogs = allBlogsData?.data.result.blogs;
    const categoriesData = await axios.get(`user/category/all-catogrey`);
    const categories = categoriesData?.data.result;
    let categoryBlogs = null;
    if (categoryName) {
      const categoryBlogsData = await axios.get(
        `user/category/filter_catogrey/?categoryName=${categoryName}&lang=${lang}`
      );
      categoryBlogs = categoryBlogsData?.data.result;
    }
    return {
      props: {
        allBlogs,
        categories,
        categoryBlogs,
        messages: require(`../../locales/${lang || "en"}.json`),
      },
    };
  } catch (error) {}
}
